module.exports = __webpack_public_path__ + "static/media/reactb.1a949617.png";